// AdmissionVoucher.jsx
import React, { useEffect, useState } from "react";

const AdmissionVoucher = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('customVoucherData');
    if (stored) {
      setData(JSON.parse(stored));
    }
  }, []);

  if (!data) return <div style={{ padding: '40px', textAlign: 'center', fontSize: '14px' }}>Loading voucher data...</div>;

  return (
    <>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { margin: 0; padding: 0; }
          .voucher-page { padding: 15px !important; box-shadow: none !important; border: none !important; }
        }
        body { font-family: 'Arial', sans-serif; color: black; margin: 0; }
        .dashed-line { border-top: 2px dashed #000; margin: 12px 0; position: relative; }
        .dashed-line::after { content: '✂️ Cut Here'; position: absolute; top: -10px; left: 50%; transform: translateX(-50%); background: white; padding: 0 8px; font-size: 10px; }
      `}</style>

      <div style={{ background: '#f3f4f6', padding: '20px', minHeight: '100vh' }}>
        <div className="voucher-page" style={{ maxWidth: '750px', margin: '0 auto', background: '#fff', padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.2)', border: '1px solid #ccc' }}>

          {/* ====== TOP SECTION (School Copy) ====== */}
          <div style={{ fontSize: '11px', fontFamily: 'Arial, sans-serif', color: '#000' }}>
            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '4px' }}>
              <div style={{ width: '70px', height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 'bold', flexShrink: 0, overflow: 'hidden', background: 'transparent', border: 'none' }}>
                {data.centerImagePath ? (
                  <img 
                    src={data.centerImagePath.startsWith('http') 
                      ? data.centerImagePath 
                      : `${process.env.REACT_APP_LIVE_DOMAIN_URL || ''}${process.env.REACT_APP_LIVE_DOMAIN_URL?.endsWith('/') ? '' : '/'}ExternalImages${data.centerImagePath.startsWith('/') ? '' : '/'}${data.centerImagePath}`} 
                    alt="Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
                  />
                ) : 'LOGO'}
              </div>
              <div style={{ textAlign: 'center', flex: 1, padding: '0 8px' }}>
                <div style={{ fontSize: '14px', fontWeight: 'bold' }}>KAHNUR EDUCATION HOUSE HIGH SCHOOL FOR BOYS & GIRLS</div>
                <div style={{ textAlign: 'right', fontSize: '11px', fontWeight: 'bold' }}>Fee Slip</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
                <img
                  src={`https://bwipjs-api.metafloor.com/?bcid=code128&text=${data.acNo}&scale=5&rotate=N&includetext=false`}
                  alt="Barcode"
                  style={{ width: '120px', height: '35px', imageRendering: 'pixelated' }}
                />
                <span style={{ fontSize: '9px', fontWeight: 'bold', marginTop: '2px' }}>{data.acNo}</span>
              </div>
            </div>

            {/* Two-column body */}
            <div style={{ display: 'flex', gap: '8px' }}>
              {/* Left column */}
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '3px' }}>
                  <span style={{ fontWeight: 'bold' }}>A/C #</span>
                  <span style={{ background: '#ddd', padding: '0 12px', fontWeight: 'bold' }}>{data.acNo}</span>
                  <span style={{ fontWeight: 'bold', marginLeft: '8px' }}>Class</span>
                  <span style={{ borderBottom: '1px solid #000', flex: 1, textAlign: 'center', fontWeight: 'bold' }}>{data.className}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '3px' }}>
                  <span style={{ fontWeight: 'bold', width: '90px', whiteSpace: 'nowrap' }}>Fee Vocher For</span>
                  <span style={{ borderBottom: '1px solid #000', flex: 1, textAlign: 'center', fontWeight: 'bold' }}>{data.feeMonth}</span>
                  <span style={{ fontWeight: 'bold', marginLeft: '8px' }}>Admission Vocher</span>
                  <span style={{ borderBottom: '1px solid #000', width: '60px' }}>{data.admissionVoucher}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '3px' }}>
                  <span style={{ fontWeight: 'bold', width: '90px' }}>Student Name</span>
                  <span style={{ borderBottom: '1px solid #000', flex: 1, fontWeight: 'bold', textTransform: 'uppercase', fontSize: '12px' }}>{data.studentName}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '3px' }}>
                  <span style={{ fontWeight: 'bold', width: '90px' }}>Father's Name</span>
                  <span style={{ borderBottom: '1px solid #000', flex: 1, fontWeight: 'bold', textTransform: 'uppercase', fontSize: '12px' }}>{data.fatherName}</span>
                </div>

                {/* Parent's Notes box */}
                <div style={{ border: '1px solid #000', height: '32px', position: 'relative', marginTop: '4px', marginBottom: '4px' }}>
                  <span style={{ position: 'absolute', top: '-8px', left: '6px', background: '#fff', padding: '0 4px', fontSize: '9px', fontWeight: 'bold', fontStyle: 'italic' }}>Parent's notes</span>
                </div>

                <div style={{ border: '1px solid #000', padding: '1px 6px', display: 'inline-block', fontWeight: 'bold', fontSize: '10px' }}>
                  School Contact # {data.contact}
                </div>
              </div>

              {/* Right column – fee breakdown */}
              <div style={{ width: '190px', fontSize: '10px', fontWeight: 'bold', borderLeft: '1px solid #eee', paddingLeft: '6px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}><span>Admission Fee</span><span style={{ fontSize: '12px' }}>{data.admissionFee}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}><span>Tution Fee</span><span style={{ fontSize: '12px' }}>{data.tutionFee}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}><span>AC Charges</span><span style={{ fontSize: '12px' }}>{data.acCharges || "0"}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}><span>Sports Fee</span><span style={{ fontSize: '12px' }}>{data.sportsFee || "0"}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}><span>Balance</span><span style={{ fontSize: '12px' }}>{data.balance}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0', alignItems: 'center' }}>
                  <span style={{ lineHeight: '1.1', fontSize: '9px' }}>Annual Stationery<br/>Charges Per Month</span>
                  <span style={{ fontSize: '12px' }}>{data.annualStationery}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}><span>Others</span><span style={{ fontSize: '12px' }}>{data.others}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}><span>Stationery</span><span style={{ fontSize: '12px' }}>{data.stationery}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0', background: '#eee', fontWeight: 'bold' }}><span>Reg Fee</span><span style={{ fontSize: '12px' }}>{data.regFee}</span></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}><span>Fine</span><span style={{ fontSize: '12px' }}>{data.fine}</span></div>
                <div style={{ marginTop: '4px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '10px' }}>
                    <span>Total Payable by {data.dueDate}</span>
                    <span style={{ fontSize: '15px', borderBottom: '2px solid #000' }}>{data.totalDue}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '10px' }}>
                    <span>Total Payable After {data.dueDate}</span>
                    <span style={{ fontSize: '15px', borderBottom: '2px solid #000' }}>{data.totalAfter}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Dashed cut line */}
          <div className="dashed-line"></div>

          {/* ====== BOTTOM SECTION (Bank Copy) ====== */}
          <div style={{ fontSize: '11px', fontFamily: 'Arial, sans-serif', color: '#000' }}>
            {/* Header / Top Part */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
              <div style={{ flex: 1, marginRight: '8px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '4px', marginBottom: '4px', fontWeight: 'bold' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    A/C # <span style={{ background: '#ddd', padding: '0 8px' }}>{data.acNo}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    Vouc # <span style={{ borderBottom: '1px solid #000', flex: 1 }}>{data.admissionVoucher}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    Class <span style={{ borderBottom: '1px solid #000', flex: 1 }}>{data.className}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                    Fee Month <span style={{ borderBottom: '1px solid #000', flex: 1, fontSize: '9px' }}>{data.feeMonth}</span>
                  </div>
                </div>

                <div style={{ marginBottom: '6px' }}>
                  <div style={{ display: 'flex', gap: '4px', fontWeight: 'bold', marginBottom: '2px' }}>
                    <span style={{ width: '90px' }}>Student Name</span>
                    <span style={{ borderBottom: '1px solid #000', flex: 1, textTransform: 'uppercase', fontSize: '12px' }}>{data.studentName}</span>
                  </div>
                  <div style={{ display: 'flex', gap: '4px', fontWeight: 'bold' }}>
                    <span style={{ width: '90px' }}>Father's Name</span>
                    <span style={{ borderBottom: '1px solid #000', flex: 1, textTransform: 'uppercase', fontSize: '12px' }}>{data.fatherName}</span>
                  </div>
                </div>
              </div>
              
              {/* Barcode */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
                <img
                  src={`https://bwipjs-api.metafloor.com/?bcid=code128&text=${data.acNo}&scale=5&rotate=N&includetext=false`}
                  alt="Barcode"
                  style={{ width: '120px', height: '35px', imageRendering: 'pixelated' }}
                />
                <span style={{ fontSize: '9px', fontWeight: 'bold', marginTop: '2px' }}>{data.acNo}</span>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
              <div style={{ flex: 1, fontWeight: 'bold' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f3f3f3', padding: '4px 6px' }}>
                  <span>Total Payable by {data.dueDate}</span>
                  <span style={{ fontSize: '18px', borderBottom: '2px solid #000', padding: '0 8px' }}>{data.totalDue}</span>
                </div>
              </div>
              <div style={{ flex: 1, fontWeight: 'bold', fontSize: '10px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 10px', borderBottom: '1px solid #000' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '1px 0', borderRight: '1px solid #ccc', paddingRight: '4px' }}><span>Tution Fee</span><span style={{ fontSize: '12px' }}>{data.tutionFee}</span></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '1px 0', paddingLeft: '4px' }}><span>Balance</span><span style={{ fontSize: '12px' }}>{data.balance}</span></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '1px 0', borderRight: '1px solid #ccc', paddingRight: '4px' }}><span>AC Charges</span><span style={{ fontSize: '12px' }}>{data.acCharges || "0"}</span></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '1px 0', paddingLeft: '4px' }}><span>Sports Fee</span><span style={{ fontSize: '12px' }}>{data.sportsFee || "0"}</span></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '1px 0', borderRight: '1px solid #ccc', paddingRight: '4px' }}><span>Transprot Fee</span><span style={{ fontSize: '12px' }}>{data.transportFee}</span></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '1px 0', paddingLeft: '4px' }}><span>Fine</span><span style={{ fontSize: '12px' }}>{data.fine}</span></div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '4px' }}>
                  <span>Total Payable After {data.dueDate}</span>
                  <span style={{ fontSize: '17px', borderBottom: '2px solid #000', padding: '0 4px' }}>{data.totalAfter}</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Print button */}
        <div className="no-print" style={{ textAlign: 'center', marginTop: '12px' }}>
          <button
            onClick={() => window.print()}
            style={{ background: '#2563eb', color: '#fff', padding: '8px 20px', borderRadius: '4px', border: 'none', cursor: 'pointer', fontSize: '14px' }}
          >
            Print Admission Voucher
          </button>
        </div>
      </div>
    </>
  );
};

export default AdmissionVoucher;